var map = {
	"./T1-Chest-1.png": 95833,
	"./T1-Chest-2.png": 8519,
	"./T1-Chest-3.png": 2097,
	"./T1-Chest-4.png": 75303,
	"./T2-Chest-1.png": 96453,
	"./T2-Chest-2.png": 69774,
	"./T2-Chest-3.png": 49552,
	"./T2-Chest-4.png": 798,
	"./T3-Chest-1.png": 88580,
	"./T3-Chest-2.png": 53677,
	"./T3-Chest-3.png": 29415,
	"./T3-Chest-4.png": 16320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7287;